//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Builder.js";
import "../Features/Features.Subdivision.CageManipulatorData.js";
import "../Features/Features.Subdivision.SelectCageObjectData.js";
import "../no/Features.js";
let d=[[[1,"CageManipulator",0,"Features.Subdivision.CageManipulatorData",0],[0,"CanMoveToolOnly",1,0],[0,"CanRelocateToolToSelection",1,0],[0,"CanReorientToolToSelection",1,0],[0,"FallOffFactor",1,0],[0,"FallOffMethod",1,0],[1,"FallOffObjects",0,"Features.Subdivision.SelectCageObjectData",0],[0,"MovementMethod",1,0],[0,"MovementPlane",1,"Plane",0],[0,"MovementVector",1,"Direction",0],[0,"ScalingMethod",1,0],[0,"TransformationMethod",1,0],[0,"WCSOption",1,0]],[[[],"ResetFallOffToLinear",{},0,0]],[]];
SPLM.Features.Subdivision.TransformCageData = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.TransformCageData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.TransformCageData.TransformationMethodType = Object.freeze({
    "Drag" : "Drag", "Transform" : "Transform"});

SPLM.Features.Subdivision.TransformCageData.MovementMethodType = Object.freeze({
    "WCS" : "WCS", "View" : "View", "Vector" : "Vector", "Plane" : "Plane", "Normal" : "Normal", "Edge" : "Edge"});

SPLM.Features.Subdivision.TransformCageData.WCSOptionType = Object.freeze({
    "InferredAxis" : "InferredAxis", "X" : "X", "Y" : "Y", "Z" : "Z", "YZ" : "YZ", "XZ" : "XZ", "XY" : "XY"});

SPLM.Features.Subdivision.TransformCageData.ScalingMethodType = Object.freeze({
    "Linear" : "Linear", "Planar" : "Planar", "Uniform" : "Uniform"});

SPLM.Features.Subdivision.TransformCageData.FallOffMethodType = Object.freeze({
    "None" : "None", "Selected" : "Selected", "All" : "All"});

export default SPLM;